export default class DotNet {

    protected authPublicKey: string
    protected authLoginRSA: string
    protected userSessionId: string
    protected authRefresh: string
    protected survey: string
    protected surveyHistory: string
    
    protected httpClient: any

    constructor(httpClient: any) {

        this.authPublicKey = process.env.VUE_APP_DOT_NET_API_PUBLIC_KEY
        this.authLoginRSA = process.env.VUE_APP_DOT_NET_API_LOGIN
        this.userSessionId = process.env.VUE_APP_DOT_NET_API_USER
        this.authRefresh = process.env.VUE_APP_DOT_NET_API_REFRESH
        this.survey = process.env.VUE_APP_DOT_NET_API_SURVEY
        this.surveyHistory = process.env.VUE_APP_DOT_NET_API_HISTORY

        this.httpClient = httpClient
        this.httpClient.defaults.baseURL = process.env.VUE_APP_DOT_NET_API_BASE_URL
    }
}